import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

const LabsBookingPageSkeletonConfig = [
    {
        classes: "marginTop-32 height-100 flexWrap",
        columns: [
            {
                span: 24,
                height: "70px",
                classes: "marginBottom-32",
            },
            {
                span: 11,
                rows: [
                    { span: 8, height: "36px" },
                    { span: 11, height: "64px", classes: "marginTop-12" },
                    { span: 8, height: "24px", classes: "marginTop-24" },
                    { span: 11, height: "404px", classes: "marginTop-24" },
                    { span: 8, height: "48px", classes: "marginTop-64 marginLeft-auto marginRight-auto" },
                ],
            },
            {
                span: 11,
                height: "700px",
                classes: "marginLeft-auto",
            },
        ],
    },
]

export const LabTestSkeletonConfig = [
    {
        columns: [{ span: 10, classes: "marginBoth-16 marginTop-24", rows: [{ height: "21px" }] }],
    },
    {
        classes: "",
        columns: [
            {
                span: 8,
                classes: " flexColumn",
                rows: [
                    { height: "85px" },
                    { height: "85px", classes: "marginTop-16" },
                    { height: "85px", classes: "marginTop-16" },
                    { height: "85px", classes: "marginTop-16" },
                ],
            },
            {
                span: 7,
                height: "480px",
            },
        ],
    },
]

export const SlotSelectionSkeletonConfig = [
    {
        classes: "flexColumn",
        columns: [
            {
                span: 8,
                height: "70px",
                classes: "marginTop-24 flex",
            },
            {
                span: 8,
                height: "96px",
                classes: "marginTop-24 flex",
            },
            {
                span: 8,
                classes: "marginBottom-16 marginTop-24 flex",
                rows: [
                    { height: "44px", classes: "col-2 marginTop-16 " },
                    { height: "44px", classes: "col-2 marginTop-16" },
                    { height: "44px", classes: "col-2 marginTop-16" },
                    { height: "44px", classes: "col-2 marginTop-16" },
                ],
            },
        ],
    },
    {
        columns: [
            {
                span: 8,
                classes: " flexColumn marginTop-24",
                rows: [
                    { height: "56px" },
                    { height: "56px", classes: "marginTop-16" },
                    { height: "56px", classes: "marginTop-16" },
                    { height: "56px", classes: "marginTop-16" },
                    { height: "56px", classes: "marginTop-16" },
                    { height: "56px", classes: "marginTop-16" },
                    { height: "48px", classes: "marginTop-40" },
                ],
            },
        ],
    },
]

export const RadioCardSkeletonConfig = [
    {
        classes: "flexColumn",
        columns: [
            {
                span: 8,
                height: "70px",
                classes: "marginTop-24 flex",
            },
        ],
    },
    {
        columns: [
            {
                span: 8,
                classes: "flexColumn marginTop-24",
                rows: [
                    { height: "62px" },
                    { height: "62px", classes: "marginTop-16" },
                    { height: "62px", classes: "marginTop-16" },
                    { height: "62px", classes: "marginTop-16" },
                    { height: "62px", classes: "marginTop-16" },
                    { height: "62px", classes: "marginTop-16" },
                    { height: "48px", classes: "marginTop-40" },
                ],
            },
        ],
    },
]

function LabsBookingSkeleton() {
    return (
        <div className="page-container">
            <Skeleton config={LabsBookingPageSkeletonConfig}></Skeleton>
        </div>
    )
}

export default LabsBookingSkeleton
